module.exports = __webpack_public_path__ + "static/media/saveActive.2f4c39d1.svg";